<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div aria-describedby="modalDescription"
           aria-labelledby="modalTitle"
           class="modal modal-custom-text"
           role="dialog"
      >
        <header
            id="modalTitle"
            class="modal-header"
        >
          <slot name="header">
          </slot>
          <button
              class="modal-btn-close"
              type="button"
              @click="close"
          >
            x
          </button>
        </header>

        <section class="modal-body">
          <slot name="body">
            <div id="modalBody"/>
          </slot>
        </section>

        <footer class="modal-footer">
          <div id="modalFooter"/>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ModalText',
  props: {
    statement: String,
    title: String
  },
  methods: {
    close() {
      this.$emit('close');
    }
  },
  mounted() {
    document.getElementById('modalBody').innerHTML = this.statement
    document.getElementById('modalFooter').innerHTML = this.title
  }
};
</script>